import { User } from 'commons/types/user';
import storage from 'commons/utils/storage';
import { USER_STORAGE } from 'commons/constants/store';
import { AccessTokenResponse, refreshTokenResponse } from '../models/auth';
import { BaseApi } from './api';

const authApi = {
  getAccessToken({ code, requestUri }: { code: string; requestUri: string }) {
    return BaseApi.get<AccessTokenResponse>('/accesstoken', {
      params: { code, requestUri },
      safeErrorStatus: [401],
    });
  },

  me() {
    const userStorage = JSON.parse(storage.get(USER_STORAGE) || '{}');
    const hasUserStorage = userStorage?.name;

    if (hasUserStorage) {
      return userStorage;
    }
    return BaseApi.get<User>('/me');
  },

  refreshToken() {
    return BaseApi.get<refreshTokenResponse>('/refreshtoken', {
      params: { refreshToken: storage.get('refresh_token') },
      safeErrorStatus: [401],
    });
  },
};

export default authApi;
